import React, { useEffect, useState } from "react";
import {
  Navbar,
  ClientForm,
  Button,
  TextInput,
  Dropdown,
  ClientsData,
} from "../components/indexComponents";
import "../CSS/ClientsPage.css";

function ClientsPage() {
  const [clients, setClients] = useState([]);
  const [formClient, setFormClient] = useState(false);
  const [customsFields, setCustomsFields] = useState([]);
  const [newCustomField, setNewCustomField] = useState("");
  const [isCustomFieldForm, setIsCustomFieldForm] = useState(false);
  const [clientsSelected, setClientsSelected] = useState([]);
  const [customsFieldsNames, setCustomsFieldsNames] = useState([]);
  const [selectedFields, setSelectedFields] = useState();
  const [isAddFieldForm, setAddFieldForm] = useState(false);

  /* #region  Obtenir les clients et supprimer un client */
  // Obtenir tous les clients d'un utilisateur
  const fetchClients = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/clients`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch clients");
      }

      const data = await response.json();
      const clients = data;

      setClients(clients);
      const tempArray = clients.map(() => false);
      fetchCustomsFields();
      setClientsSelected([]);
    } catch (error) {
      console.error("Error fetching clients:", error);
    }
  };

  // Pour récupérer les clients lorsque le composant est rendu
  useEffect(() => {
    fetchClients();
  }, []);

  // Fonction pour supprimer un client
  const deleteClient = async (id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/clients/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete client");
      }

      // Retirez le client de la liste des clients affichés
      setClients(clients.filter((client) => client.id !== id));
      fetchClients();
    } catch (error) {
      console.error("Error deleting client:", error);
    }
  };

  const deleteSelectedClients = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/clients`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ clientIds: clientsSelected }),
      });

      if (!response.ok) {
        throw new Error("Failed to delete client");
      }

      setClientsSelected([]);
      fetchClients();
    } catch (error) {
      console.error("Error deleting client:", error);
    }
  };
  /* #endregion */

  /* #region  Customs Fields */

  // Obtenir tous les customs fields d'un utilisateur
  const fetchCustomsFields = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/customs-fields/false/null`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch customs fields");
      }
      const data = await response.json();

      const fields = data;
      const tempArray = fields.map((customField) => customField.name);
      setCustomsFieldsNames(tempArray);
      setCustomsFields(fields);
    } catch (error) {
      console.error("Error fetching clients:", error);
    }
  };

  const createOptions = () => {
    const tempArray = [
      ...customsFields.map((customField) => ({
        value: customField,
        label: customField.name,
      })),
    ];
    setCustomsFieldsNames(tempArray);
  };

  useEffect(() => {
    createOptions();
  }, [customsFields]);

  // Enregistre quel custom field est selectionner
  const handleFieldChange = (selectedOptions) => {
    setSelectedFields(selectedOptions ? selectedOptions.value : "");
  };

  // Pour ajouter les champs personnalisées
  const addCustomField = () => {
    setIsCustomFieldForm(true);
    setNewCustomField("");
  };

  const handleSaveNewCustomField = (event) => {
    setNewCustomField(event.target.value);
  };

  // Pour créer un nouveau custom field dans la base de donnée
  const createCustomField = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/custom-field/false/null`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          customField: newCustomField,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to add custom field");
    }

    setIsCustomFieldForm(false);
    setNewCustomField("");

    await fetchClients();
  };

  // Pour enregistré dans la base de donnée quels clients a quel custom field
  const addCustomFieldToSelected = async () => {
    const customFieldToAdd = {
      custom_field: selectedFields.name,
      completed: false,
      id: selectedFields.id,
    };
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/clients/custom-field/false`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          clientIds: clientsSelected,
          customField: customFieldToAdd,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to add custom field");
    }

    setIsCustomFieldForm(false);
    setClientsSelected([]);

    await fetchClients();
  };

  /* #endregion */

  /* #region  Selectionner les clients */
  function handleSelectedClientsChange(selectedClients) {
    setClientsSelected(selectedClients);
    console.log(selectedClients);
  }

  /* #endregion */

  return (
    <div className="ClientsPage page-frame">
      <Navbar />
      <div className="page-content">
        <h1>Vos Clients</h1>
        <div className="add-client-container">
          {formClient ? (
            ""
          ) : (
            <button
              onClick={() => {
                setFormClient(true);
              }}
              className="add-client-btn"
            >
              Ajouter un(e) client(e)
            </button>
          )}
          {formClient ? (
            <ClientForm
              onClientAdded={fetchClients}
              close={() => {
                setFormClient(false);
              }}
            />
          ) : (
            <div></div>
          )}
        </div>

        <div className="client-list">
          <div className="btn-custom-field">
            <Button
              text="Créer un champ personnalisé"
              onClick={() => {
                setIsCustomFieldForm(true);
                addCustomField();
              }}
            />
            <Button
              text="Ajouter un champ personnalisé"
              onClick={() => {
                setAddFieldForm(true);
              }}
            />
          </div>
          {isCustomFieldForm ? (
            <>
              <TextInput
                labelText="Nom du champs"
                name="customs_fields"
                type="text"
                value={newCustomField}
                onChange={(e) => {
                  handleSaveNewCustomField(e);
                }}
              />
              {/* <Button text="Ajouter" onClick={handleCustomsFieldsChange} /> */}
              <Button text="Créer" onClick={createCustomField} />
            </>
          ) : (
            ""
          )}
          {isAddFieldForm ? (
            <div className="dropdown-container">
              <Dropdown
                options={customsFieldsNames}
                onChange={handleFieldChange}
                placeholder="Sélectionner un champ"
              />
              <Button
                text="Ajouter au clients sélectionnés"
                onClick={addCustomFieldToSelected}
              />
              <button
                onClick={() => {
                  setAddFieldForm(false);
                }}
              >
                Annuler
              </button>
            </div>
          ) : (
            ""
          )}

          <h2>Liste des clients</h2>
          {/* <Button text={!isAllSelected ? 'Tous sélectionner' : 'Annuler la sélection'} onClick={selectAll} className="select-all-btn"/> */}

          <ClientsData
            clients={clients}
            onDeleteClient={deleteClient}
            onSelectedClientsChange={handleSelectedClientsChange}
            onClientAdded={fetchClients}
            isTeam={false}
          />
          {clientsSelected.length > 0 ? (
            <button className="btn-supprimer" onClick={deleteSelectedClients}>
              Supprimer les clients selectionnés
            </button>
          ) : (
            ""
          )}

          {/*               <ul className='ul-client'>
                {clients.map((client, index) => (
                  <li key={client.id}>
                    <ClientCard client={client} onClick={() => {const tableauModifie = isPopupDisplayed.slice(); tableauModifie[index] = true; setIsPopupDisplayed(tableauModifie)}} onClientAdded={fetchClients} edit={true} isTeam={false} isChecked={isSelected(index)} onCheck={() => {onCheck(index)}} />
                    {isPopupDisplayed[index] ? 
                      <PopupConfirm text={`Voulez-vous vraiment supprimer ${client.name} définitivement ?`} textBtnConfirm="Supprimer" onClickConfirm={() => {deleteClient(client.id)}} textBtnCancel="Annuler" onClickCancel={() => {const tableauModifie = isPopupDisplayed.slice(); tableauModifie[index] = false; setIsPopupDisplayed(tableauModifie)}} />
                    :
                      ''
                    }
                  </li>
                ))}
              </ul> */}
        </div>
      </div>
    </div>
  );
}

export default ClientsPage;
